









import { State } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'

@Component
class Loading extends Vue {
  @State(state => state.loading.show) show!: boolean

  msg = '正在加载'
  loadingGif = 'https://cdn.schoolpal.cn/scp/frontend/loading.gif'
}

export default Loading
